<template>
  <div>
    <div class="quote">
      {{ quote.text }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['quote']),
  },
};
</script>

<style scoped>
.quote {
  text-align: center;
  font-size: 200%;
  padding: 0 20px;
}
</style>
